import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";
import React, { useContext } from "react";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { QuickAddProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import {
  IQuickAddEventParams,
  QuickAddTrackingEventsContextBaseProvider,
} from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddTrackingEventsContext/__internal__/QuickAddTrackingEventsProviders/QuickAddTrackingEventsContextBaseProvider";

export const LayoutElementQuickAddTrackingEventsContextProvider = ({
  data,
  children,
}: {
  data: QuickAddProps;
  children: React.ReactNode;
}) => {
  const { layoutElement, productTileActions } = useContext(Context);

  const productPartial = ILeanProductTile.ILeanProduct.build({
    token: data.productToken,
    promoted_by: data.promotedBy,
    impression_id: data.impressionId,
  });

  const onQuickAddClick = ({ newQuantity }: IQuickAddEventParams) => {
    productTileActions?.onQuickAdd?.(
      productPartial,
      layoutElement.on_click_event_name,
      newQuantity
    );
  };
  const onChooseOption = () => {
    productTileActions?.onChooseOption?.(
      productPartial,
      layoutElement.on_click_event_name
    );
  };

  const onChooseOptionQuantityUpdate = ({
    newQuantity,
  }: IQuickAddEventParams) => {
    productTileActions?.onChooseOptionQuantityUpdate?.(
      productPartial,
      layoutElement.on_click_event_name,
      newQuantity
    );
  };

  return (
    <QuickAddTrackingEventsContextBaseProvider
      data={data}
      onQuickAddButtonClick={onQuickAddClick}
      onChooseOptionClick={onChooseOption}
      onChooseOptionQuantityUpdateSubmit={onChooseOptionQuantityUpdate}
    >
      {children}
    </QuickAddTrackingEventsContextBaseProvider>
  );
};
